import React, { useContext } from "react";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GlobalContext } from "../../context/GlobalState";
import workspaces from "../../services/api/workspaces";
import users from "../../services/api/users";

const SettingsLink = ({ workspace, index, arrayLength }) => {
  const {
    currentWorkspace,
    setCurrentWorkspace,
    setSpotlights,
    userData,
    updateUser,
  } = useContext(GlobalContext);
  const isCurrent = currentWorkspace.id === workspace.id;

  const handleClick = async () => {
    if (isCurrent) {
      //   console.log("Same");
      return;
    } else {
      try {
        const { data: newCurrentWorkspace } = await workspaces.find({
          id: workspace.id,
        });
        setCurrentWorkspace({
          id: newCurrentWorkspace.id,
          hasBillingCard: newCurrentWorkspace.hasBillingCard,
          name: newCurrentWorkspace.name,
          currentPlan: newCurrentWorkspace.currentPlan,
        });
        const rolesObj = userData.roles;
        // console.log(newCurrentWorkspace.name, rolesObj[newCurrentWorkspace.id]);

        const currentRole = rolesObj[newCurrentWorkspace.id].role;
        const isAdmin = currentRole === "admin" || currentRole === "owner";

        updateUser({ isAdmin });
        setSpotlights([]);
      } catch (error) {
        console.log(error);
      }
    }
  };
  const isLast = index === arrayLength - 1;

  return (
    <div
      className={`${container} ${!isLast && borderBottom}`}
      onClick={handleClick}
    >
      <p>{workspace.name}</p>
      {isCurrent && <FontAwesomeIcon className="check" icon="check" />}
    </div>
  );
};

export default SettingsLink;

const container = css`
  user-select: none;
  text-decoration: none;
  padding: ${boxStyles.desktopPadding};
  color: ${colors.brandColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  p {
    color: ${colors.titleColor};
    font-size: ${textSizes.subtitle};
    font-weight: 500;
    flex: 1;
  }
  .check {
    color: ${colors.brandColor};
  }
`;

const borderBottom = css`
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    border-bottom: 1px solid ${colors.lineBreak};
  }
`;
